<template>
  <AModal modal-class="d-activity-repost-modal modal-lg">
    <div class="overlay" />

    <div class="modal-content">
      <div
        class="modal-body loadable"
        :class="{ 'loading': isProcessing }"
      >
        <div
          v-if="isProcessing"
          class="loading-content"
        >
          <DuiLoadingIndicator size="lg" />
          <p class="space-top-2em">
            Reposting...
          </p>
        </div>

        <div class="loaded-content">
          <div class="space-bottom-2em">
            <span class="label label-sm label-round">
              Repost
              <DuiIconRepost
                class="repost-icon icon-sm2"
                style="margin: -4px 0;"
              />
            </span>
            <a
              class="button button-icon button-close button-close-modal"
              @click="dismiss"
            />
          </div>

          <div class="original-activity">
            <DActivityActivity
              :activity="activity"
              :is-repost="true"
            />
          </div>

          <div>
            <DTextCompose
              ref="contentText"
              v-model="content"
              :alt-font="true"
              :disabled="isProcessing"
              placeholder="Add comment..."
            />
          </div>

          <div class="button-pair right space-top-3em">
            <button
              :disabled="isProcessing"
              type="button"
              @click="dismiss"
            >
              Cancel
            </button>
            <button
              class="button-yellow"
              :disabled="isProcessing"
              type="button"
              @click="submit"
            >
              Repost
            </button>
          </div>
        </div>
      </div>
    </div>
  </AModal>
</template>

<script>
import Vue from 'vue';

import AModal from '@d-components/a-modal/a-modal.vue';
import DActivityActivity from '@d-components/d-activity-feed/d-activity-entry/d-activity-activity.vue';
import DTextCompose from '@d-components/d-text-compose/d-text-compose.vue';
import activityFeedService from '@d-services/activity-feed-service/activity-feed-service';
import { getErrorMessage } from '@d-shared/utils/errors';

export default {
  components: {
    AModal,
    DActivityActivity,
    DTextCompose,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    content: null,
    isProcessing: false,
  }),
  methods: {
    dismiss() {
      this.$emit('dismiss');
    },

    async submit() {
      this.$set(this, 'isProcessing', true);

      try {
        const postData = {
          post: {
            content: this.content,
            repost_id: this.activity.slug,
            type: 'Post',
          },
        };

        const mentions = this.$refs.contentText.getMentions();
        if (mentions && mentions.length) {
          postData.post.mentions_list = mentions;
        }

        const newPost = await activityFeedService.addPost(postData);
        Vue.duiNotificationManager.success('Reposted');
        this.$emit('post-created', newPost);
        this.dismiss();
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }

      this.$set(this, 'isProcessing', false);
    },
  },
};
</script>

<style lang="scss">
@import "@dui-styles/base";
@import "../../../../activity";

.d-activity-repost-modal {
  .modal-content {
    overflow: visible;
  }

  .d-activity-activity {
    @include activityStyling();
  }

  .original-activity {
    @include originalActivityStyling();

    max-height: 30vh;
    overflow: hidden;
    position: relative;

    &:after {
      background-image: linear-gradient(to top, getColor($grey, base) 40%, $color-transparent-grey);
      bottom: 0;
      content: "";
      height: $_2em;
      left: 0;
      position: absolute;
      width: 100%;
      z-index: 1;
    }
  }

  .d-text-compose {
    margin-top: $_2em;
    padding: 0;

    @include activityDTextCompose();
  }
}
</style>
